/** The release version embedded in the web bundle from its package manifest. */
export const APP_VERSION = __CGRAPH_WEB_VERSION__;
